import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const options = [
  { label: 'Municipal', value: 'city' },
  { label: 'Estadual', value: 'state' },
  { label: 'Federal', value: 'federal' },
  { label: 'Autarquia', value: 'autarchy' },
]

export const strategy = optionsToStrategy(options)
